export default function FeatureCards() {
  const features = [
    {
      title: 'Gestione Dati',
      subtitle: 'Intelligente',
      description: 'Organizza e analizza informazioni con strumenti moderni e intuitivi, progettati per semplificare il tuo flusso di lavoro quotidiano.',
      bgClass: 'bg-foreground-900',
      textClass: 'text-background-50',
      iconBg: 'bg-background-800/30',
      iconText: 'GD',
    },
    {
      title: 'Prodotti',
      subtitle: 'di Qualità',
      description: 'Scopri una selezione curata di prodotti moda e accessori disponibili attraverso itaobuy sheet.',
      bgClass: '',
      textClass: 'text-background-50',
      isImage: true,
      image: 'https://readdy.ai/api/search-image?query=Artistic%20flat%20lay%20of%20premium%20fashion%20pieces%20on%20raw%20linen%20surface%2C%20silk%20scarf%20draping%20over%20leather%20journal%2C%20gold%20toned%20sunglasses%2C%20soft%20directional%20daylight%2C%20warm%20ivory%20and%20camel%20tones%2C%20high%20fashion%20editorial%20still%20life%2C%20sophisticated%20European%20aesthetic&width=800&height=600&seq=feat-prod-v2&orientation=landscape',
    },
    {
      title: 'Sicurezza',
      subtitle: 'Garantita',
      description: 'La protezione dei tuoi dati è la nostra priorità. Scopri le migliori pratiche per utilizzare itaobuy sheet in totale sicurezza.',
      bottomImage: 'https://readdy.ai/api/search-image?query=Modern%20home%20office%20corner%20with%20desktop%20monitor%20showing%20abstract%20data%20visualization%2C%20potted%20monstera%20plant%20beside%20it%2C%20warm%20afternoon%20light%20through%20sheer%20curtains%2C%20sage%20green%20and%20warm%20oak%20tones%2C%20European%20interior%20design%2C%20calm%20productive%20atmosphere&width=600&height=400&seq=feat-secu-v2&orientation=landscape',
    },
  ];

  return (
    <section className="w-full bg-background-50 py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-10">
        <div className="mb-10">
          <span className="text-xs tracking-[0.15em] uppercase text-foreground-500 font-label">
            Itaobuy
          </span>
          <span className="text-xs tracking-[0.15em] uppercase text-foreground-400 font-label ml-2">
            Spreadsheet
          </span>
        </div>

        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 font-heading max-w-2xl mb-14">
          Perché scegliere{' '}
          <span className="italic font-normal">Itaobuy Spreadsheet</span>?
        </h2>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
          {features.map((feature, idx) => {
            if (feature.isImage) {
              return (
                <div
                  key={idx}
                  className="relative rounded-3xl overflow-hidden h-[420px] group cursor-pointer"
                >
                  <img
                    src={feature.image}
                    alt="Itaobuy Spreadsheet prodotti qualità"
                    title="Itaobuy Spreadsheet - prodotti di qualità"
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent"></div>
                  <div className="absolute top-4 left-4">
                    <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-foreground-900/60 backdrop-blur-sm rounded-full text-xs text-background-50 font-label">
                      <i className="ri-shopping-bag-line"></i>
                      {feature.subtitle}
                    </span>
                  </div>
                  <div className="absolute bottom-6 left-6 right-6">
                    <h3 className="text-xl md:text-2xl font-bold text-background-50 font-heading">
                      {feature.title}
                    </h3>
                    <p className="mt-2 text-sm text-background-200 font-body leading-relaxed">
                      {feature.description}
                    </p>
                  </div>
                </div>
              );
            }

            return (
              <div
                key={idx}
                className={`rounded-3xl p-8 flex flex-col justify-between min-h-[420px] ${
                  feature.bgClass || 'bg-background-50 border border-background-200/60'
                } ${feature.textClass || 'text-foreground-900'}`}
              >
                <div>
                  {feature.iconBg && (
                    <div className={`w-12 h-12 rounded-2xl ${feature.iconBg} flex items-center justify-center mb-6`}>
                      <span className="text-sm font-bold font-label">{feature.iconText}</span>
                    </div>
                  )}
                  <h3 className={`text-2xl md:text-3xl font-bold ${feature.textClass || 'text-foreground-900'} font-heading`}>
                    {feature.title}
                  </h3>
                  <p className={`mt-2 text-sm ${feature.textClass ? 'text-background-300' : 'text-foreground-500'} font-body`}>
                    {feature.subtitle}
                  </p>
                </div>
                <div>
                  <p className={`text-sm ${feature.textClass ? 'text-background-300' : 'text-foreground-600'} font-body leading-relaxed`}>
                    {feature.description}
                  </p>
                  {feature.bottomImage && (
                    <div className="mt-6 rounded-2xl overflow-hidden h-36">
                      <img
                        src={feature.bottomImage}
                        alt="Itaobuy Spreadsheet sicurezza"
                        title="Itaobuy Spreadsheet - sicurezza garantita"
                        className="w-full h-full object-cover"
                      />
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}